exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-credential[data-v-92eda9ca]{position:relative;padding:1em 0;border-bottom:1px solid grey}.single-credential.loading[data-v-92eda9ca]:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:grey;opacity:.3}.header[data-v-92eda9ca]{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
